import { connect } from 'react-redux';
import { requestToggleTheaterView } from '../../../DeviationPage/redux/actions';
import { getIsTheaterForced } from '../../../DeviationPage/redux/selectors';
var mapStateToProps = function (state, _a) {
    var deviation = _a.deviation;
    return ({
        isTheaterForced: getIsTheaterForced(state, deviation),
    });
};
var mapDispatchToProps = {
    onClick: requestToggleTheaterView,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=TheaterButton.container.js.map